export default __webpack_public_path__ + "static/media/Divyam.0ace74c7.jpg";